export default __webpack_public_path__ + "static/mock-up-784c2b3cae5e5aa718dc1170a1d91506.jpg";